import classNames from 'classnames';
import { useState } from 'react';
import Button from '../Button';
import Icon from '../Icon';

interface Props {
  status?: 'error' | 'success';
  errorMsg?: string;
  name?: string;
  acceptFiles?: string;
  id?: string;
}

function InputFileExt({
  status,
  errorMsg,
  name = '',
  acceptFiles,
  id = ''
}: Props) {
  const [fileName, setFileName] = useState<string | null>(
    null
  );

  const handleChange = (e: React.BaseSyntheticEvent) => {
    if (e.target?.files)
      setFileName(e.target?.files[0].name);
  };

  return (
    <div
      className={classNames([
        'relative flex min-h-[158px] items-center rounded-xl border-2 border-dashed p-6',
        !status && ' border-sl-blue border-opacity-25',
        status === 'success' && 'border-sl-green',
        status === 'error' && 'border-sl-red'
      ])}
    >
      <input
        type="file"
        name={name}
        id={id}
        onChange={handleChange}
        className="z-1 absolute inset-0 cursor-pointer opacity-0"
        accept={acceptFiles}
      />
      <div className="flex flex-1 flex-wrap items-center justify-center gap-4">
        <span
          className={classNames([
            'font-circular text-sm font-medium !leading-none text-sl-blue',
            fileName && 'hidden'
          ])}
        >
          drag & drop of
        </span>
        <Button
          text={fileName || 'selecteer bestand'}
          color="accent"
          size="sm"
        />
      </div>
      <span
        className={classNames([
          'peer absolute right-1 top-1.5 mr-[2px] p-2 text-lg !leading-none transition-opacity duration-300',
          status === 'error' && 'text-sl-red',
          status === 'success' && 'text-sl-green'
        ])}
      >
        <Icon
          icon="checkmark"
          className={`${
            status === 'success' ? 'block' : 'hidden'
          }`}
        />
        <Icon
          icon="circle-info"
          className={`${
            status === 'error' ? 'block' : 'hidden'
          }`}
        />
      </span>
      {errorMsg && status === 'error' && (
        <span className="invisible absolute bottom-full right-0 -mr-[2px] -mb-[6px] max-w-full rounded-lg border border-sl-red border-opacity-20 bg-[#f9e8e8] px-2 py-1 text-left font-sans text-xs font-normal text-sl-red peer-hover:visible">
          <span>{errorMsg}</span>
          <span className="absolute right-5 -bottom-1 h-2 w-2 rotate-[135deg] border-t border-r border-sl-red border-opacity-20 bg-[#f9e8e8]" />
        </span>
      )}
    </div>
  );
}

export default InputFileExt;
